module.exports = __webpack_public_path__ + "img/54.562c1814.png";